module.exports = __webpack_public_path__ + "static/img/teacher_info.31f4cba6.png";